var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGerenciar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#3C3C3B",
    strokeWidth: 2,
    d: "M11.108 3.087c1.398 1.398 1.509 3.68.457 5.695l2.29 2.079 7.827-7.46c.773-.737 1.987-.737 2.76 0l.06.057c.759.722.787 1.923.065 2.681l-.065.065-7.696 7.335 6.906 6.27c.73.662.784 1.79.122 2.52-.039.043-.08.084-.122.122l-.112.101c-.762.693-1.926.693-2.688 0l-6.946-6.305-3.447 3.286c-.6.571-1.465.7-2.183.385L7.188 21.01l.593.479c.43.347.497.976.15 1.406-.07.087-.155.162-.25.221l-3.304 2.052c-.378.235-.866.192-1.196-.106l-1.574-1.415c-.366-.329-.438-.874-.172-1.287l1.945-3.006c.3-.464.919-.597 1.382-.297.03.02.058.04.086.062l.781.632 1.495-1.424c-.064-.542.105-1.107.51-1.533l.065-.064 3.316-3.163-2.147-1.949c-2.088 1.234-4.537 1.19-6.01-.283-1.233-1.234-2.08-3.693-.78-4.974.062-.06.12-.12.175-.177l.087-.096.073.087.08.084 2.016 2.017c.74.74 1.916.779 2.701.116l.128-.116L8.39 7.222c.74-.74.779-1.915.117-2.7l-.117-.128-2.017-2.017c-.049-.049-.1-.095-.152-.137 1.363-1.297 3.675-.364 4.886.847z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGerenciar);
export default __webpack_public_path__ + "static/media/icon_gerenciar.cc416d44c747ef526a3857366e60f4b0.svg";
export { ForwardRef as ReactComponent };